import { ToolbarIconButton } from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { LearnDeckHistoryContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";

import { useHistoryStepSpinner } from "#use-history-step-spinner";

export function RedoReviewButton({ isTransitioning }: { isTransitioning: boolean }) {
  const [enabled, action, pending, pendingStep] = useContextSelectors(
    LearnDeckHistoryContext,
    (c) => c.canGoForward,
    (c) => c.goForward,
    (c) => c.isPending,
    (c) => c.pendingStep,
  );
  const showsSpinner = useHistoryStepSpinner(pending && pendingStep !== "back");
  return (
    <ToolbarIconButton
      accessibilityLabel="Redo"
      className="ml-0 border-0 bg-transparent shadow-none"
      disabled={!enabled || pending || isTransitioning}
      iconSize={20}
      isLoading={showsSpinner}
      name="IoMdRedo"
      onPress={action}
      size="menu"
      testID="learn-redo-review-button"
    />
  );
}
